import { CreateWebsiteBanner } from '../standalone-banners/create-website-banner';
import { DevCenterBanner } from '../standalone-banners/dev-center-banner';
import { Promo, promoSectionDTOtoProps } from './partials/Promo';
import { CategoriesCarousel, categoriesCarouselSectionDTOtoProps, } from './partials/CategoriesCarousel';
import { Solution, solutionsSectionDTOtoProps, } from './partials/solution-grid-homepage';
import { Discovery, discoverySectionDTOtoProps } from './partials/discovery';
export var SectionType;
(function (SectionType) {
    SectionType["PROMO"] = "PROMO";
    SectionType["COLLECTION"] = "COLLECTION";
    SectionType["CATEGORY"] = "CATEGORY";
    SectionType["DEVCENTER_BANNER"] = "DEVCENTER_BANNER";
    SectionType["WEBSITE_BANNER"] = "WEBSITE_BANNER";
    SectionType["DISCOVERY"] = "DISCOVERY";
})(SectionType || (SectionType = {}));
export var SupportedComponents = {
    PROMO: { component: Promo, propsMapper: promoSectionDTOtoProps },
    COLLECTION: { component: Solution, propsMapper: solutionsSectionDTOtoProps },
    CATEGORY: {
        component: CategoriesCarousel,
        propsMapper: categoriesCarouselSectionDTOtoProps,
    },
    DEVCENTER_BANNER: { component: DevCenterBanner },
    WEBSITE_BANNER: { component: CreateWebsiteBanner },
    DISCOVERY: { component: Discovery, propsMapper: discoverySectionDTOtoProps },
};
//# sourceMappingURL=SupportedComponents.js.map